import script from "./breadcrumb.vue?vue&type=script&setup=true&lang=ts"
export * from "./breadcrumb.vue?vue&type=script&setup=true&lang=ts"

import "./breadcrumb.vue?vue&type=style&index=0&id=719c35eb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-719c35eb"]])

export default __exports__